import React, { useEffect } from "react";

import ProductDetail from "../../components/productDetail/ProductDetail";
import { useRouter } from "next/router";
import { TagTypes } from "../../commonTypes";
import type { Product } from "../../commonTypes";
import { ProductService } from "../../services/product.service";
import { getAllProductSlugs } from "../../modules/@supabase/products";

interface ProductPageProps {
  product: Product | null;
}

const ProductPage = ({ product }: ProductPageProps) => {
  const router = useRouter();

  useEffect(() => {
    // @ts-ignore
    if (product && typeof window !== "undefined" && window?._learnq) {
      // Klaviyo Tracking
      var item = {
        ProductName: product.name,
        ProductID: product.id,
        SKU: product?.product_variants[0]?.sku,
        Categories: product.product_tags
          .filter((tag) => tag.tags.type === TagTypes.CATEGORY)
          .map((tag) => tag.tags?.name),
        ImageURL: product?.images[0],
        URL: `https://www.orcollective.co.uk/products/${product.slug}`,
        Brand: product.product_tags.find(
          (tag) => tag.tags.type === TagTypes.BRAND
        )?.tags?.name,
      };
      //@ts-ignore
      window._learnq.push(["track", "Viewed Product", item]);
    }
  }, [product]);

  // Handle fallback state for SSG
  if (router.isFallback) {
    return <div className="empty-message">loading...</div>;
  }

  if (product) {
    return <ProductDetail product={product} />;
  } else {
    return <div className="empty-message">no product found</div>;
  }
};

export async function getStaticProps({ params }) {
  const { slug } = params;
  const product = await ProductService.getProductBySlug(slug);

  return {
    props: {
      product: product || null,
    },
    // Revalidate every 60 seconds for ISR
    revalidate: 60,
  };
}

export const getStaticPaths = async () => {
  const slugs = await getAllProductSlugs();

  const paths = slugs.map((slug) => ({
    params: { slug },
  }));

  return {
    paths,
    fallback: true,
  };
};

export default ProductPage;
